import { LOCKED, LOCKED_MANUAL } from '#util/pagination/helpers'

export function cleanLockedPageBreak(
  value: string | null | undefined,
): string | null {
  if (typeof value === 'string') {
    if (value.startsWith(`${LOCKED_MANUAL}:`)) return 'manual'
    if (value.startsWith(`${LOCKED}:`)) return null
  }
  return value ?? null
}

export function withLockedPageBreak(
  pageNumber: string | number,
  wasManual = false,
): string {
  return `${wasManual ? LOCKED_MANUAL : LOCKED}:${pageNumber}`
}
